import {
  AutoUpdateGarpCellRequest,
  AutoUpdateGarpCellResponse,
  garpApi,
} from '@texas/api/endpoints/erp/garpApi';
import { useAutoUpdateForm } from '@texas/components/shared/autoUpdate/useAutoUpdateForm';

export const useGarpCellForm = ({
  variantId,
  branchId,
  cellX,
  cellY,
  defaultValues,
}: {
  variantId: number;
  branchId: number;
  cellX: number;
  cellY: number;
  defaultValues: AutoUpdateGarpCellRequest;
}) => {
  const {
    register,
    registerAutoUpdate,
    triggerSubmit,
    form,
    control,
    watch,
    formState,
    setValue,
  } = useAutoUpdateForm<AutoUpdateGarpCellRequest, AutoUpdateGarpCellResponse>({
    autoUpdateRequest: garpApi.autoUpdateCell,
    requestParams: [variantId, branchId, cellX, cellY],
    namePrefix: 'garp-cell',
    defaultValue: defaultValues,
  });

  return {
    register,
    registerAutoUpdate,
    triggerSubmit,
    form,
    control,
    watch,
    formState,
    setValue,
  };
};
